import hfConfig from 'hfConfig';
import $ from 'jquery';
import Mustache from 'mustache';
import headerData from 'header.data';
import headerAnalytics from 'header.analytics';
import '../shared/sv-hover-intent.js';
import utils from '../shared/utils';

let headerMainFlyout = {};

headerMainFlyout.templates = {};

headerMainFlyout.templates.desktopSection = '' +
  '<div class="MainFlyout__wrapper MainFlyout__wrapper--border">' +
  '<header>' +
  '{{#allLink}}<a href="{{allLink}}" class="MainFlyout__header">{{header}}</a>{{/allLink}}' +
  '{{^allLink}}<span class="MainFlyout__header">{{header}}</span>{{/allLink}}' +
  '</header>' +
  '<ul class="MainFlyout__list">' +
  '{{#links}}' +
  '<li class="MainFlyout__item">' +
  '<a href="{{url}}" class="MainFlyout__link"{{#sub}} data-level="{{sub}}"{{/sub}} title="{{name}}"{{#direct}} data-type="direct"{{/direct}}>{{name}}</a>' +
  '</li>' +
  '{{/links}}' +
  '{{#allLink}}' +
  '<li class="MainFlyout__item">' +
  '<a href="{{allLink}}" class="MainFlyout__link" title="View All {{name}}" data-type="direct">View All {{name}}</a>' +
  '</li>' +
  '{{/allLink}}' +
  '</ul>' +
  '</div>';

headerMainFlyout.templates.desktopFeature = '' +
  '<div class="MainFlyout__wrapper">' +
  '<span class="MainFlyout__detailsHeader">{{{title}}}</span>' +
  '<a href="{{link}}" class="bttn-outline bttn--cta bttn--force-left">' +
  '<span class="bttn__content">{{cta}}</span>' +
  '</a>' +
  '</div>';

headerMainFlyout.templates.level1Flyout = '' +
  '<ul class="MainFlyout__list">' +
  '{{#l1}}' +
  '{{^hideL1}}' +
  '<li class="MainFlyout__item">' +
  '<a href="{{link}}" class="MainFlyout__link{{#activeHolidayClass}} MainFlyout__link--{{activeHolidayClass}}{{/activeHolidayClass}}" data-level="{{name}}" data-image="{{feature.image}}" data-title="{{feature.title}}" data-cta="{{feature.cta}}" data-link="{{feature.link}}" title="{{name}}">{{name}}</a>' +
  '</li>' +
  '{{/hideL1}}' +
  '{{/l1}}' +
  '</ul>';

headerMainFlyout.logEventPath = function _logEventPath(type, pathArray) {
  // Get header at the beginning, then join them all
  return headerAnalytics.logEvent(type, ['header'].concat(pathArray).join('>'));
};

headerMainFlyout.stopTouchHandling = function _stopTouchHandling(event) {
  // If this is a touch interaction
  if (event?.type === 'touchend') {
    // Prevent the normal behavior
    event.preventDefault();
    event.stopPropagation();
  }
};

headerMainFlyout.setMenuState = function _setMenuState(state) {
  const mainFlyoutClasses = document.querySelector('.MainFlyout');
  mainFlyoutClasses?.classList?.toggle('MainFlyout--panels-3', (state === 'level2'));
  mainFlyoutClasses?.classList?.toggle('MainFlyout--panels-4', (state === 'level3'));
};

headerMainFlyout.highlightLink = function _highlightLink(menu, item) {
  const mainFlyoutActiveLinks = document.querySelector(menu)?.querySelectorAll('.MainFlyout__link--active');
  Array.from(mainFlyoutActiveLinks).forEach((link) => {
    link.classList?.remove('MainFlyout__link--active');
  })
  item?.classList?.add('MainFlyout__link--active');
};

headerMainFlyout.clearUrl = function _clearUrl(urlString) {
  // Need to ensure this value isn't just a placeholder
  // if it is, we need to remove the string so Mustache can tell.
  return urlString === '#' ? '' : urlString;
};

headerMainFlyout.interactWithLevel1Link = function _interactWithLevel1Link(event) {
  const isEventTypeHoverIntent = event?.target ? false : true;
  let level1Data;
  let level1Name;
  let level1Url;
  let requestLevel2Data;
  
  if(isEventTypeHoverIntent) {
    level1Data = event?.dataset;
    level1Name = event?.textContent;
    level1Url = event?.getAttribute('href');
  } else {
    level1Data = event?.target?.dataset;
    level1Name = event?.target?.textContent;
    level1Url = event?.target?.getAttribute('href');
  }
  
  if (event.type !== 'click') {
    requestLevel2Data = headerData.getLevel2Data(level1Data.level);

    if(isEventTypeHoverIntent) {
      headerMainFlyout.highlightLink('.MainFlyout__level1', event);
      headerMainFlyout.stopTouchHandling(event);
    } else {
      headerMainFlyout.highlightLink('.MainFlyout__level1', event?.target);
      headerMainFlyout.stopTouchHandling(event);
    }
    
    requestLevel2Data.then(function _renderLevel2Data(level2Data) {
      const htmlContent = Mustache.render(headerMainFlyout.templates.desktopSection, {
        header: level1Name,
        links: level2Data,
        allLink: headerMainFlyout.clearUrl(level1Url),
        name: level1Name
      });

      utils.setInnerHtml('.MainFlyout__level2', htmlContent);

      const level1Details = document.querySelector('.MainFlyout__level1Details');
      level1Details?.setAttribute('style', `background-image:url('${level1Data.image}')`);
      utils.setInnerHtml('.MainFlyout__level1Details', Mustache.render(headerMainFlyout.templates.desktopFeature, level1Data));

      headerMainFlyout.setMenuState('level2');
      
      //registering event listeners for MainFlyout level2 & level1Details after they are added
      headerMainFlyout.registerHoverIntent('.MainFlyout__level2 .MainFlyout__link', headerMainFlyout.interactWithLevel2Link);
    });
  } else {
    headerMainFlyout.logEventPath('header click', ['all departments', level1Name]);
  }
};

headerMainFlyout.logLevel2Link = function _logLevel2Link(event) {
  const level1Name = document.querySelector('.MainFlyout__level1 .MainFlyout__link--active')?.dataset?.level;
  const level2Name = event?.target?.textContent;

  headerMainFlyout.logEventPath('header click', ['all departments', level1Name, level2Name]);
};

headerMainFlyout.interactWithLevel2Link = function _interactWithLevel2Link(event) {
  const isEventTypeHoverIntent = event?.target ? false : true;
  let level1Name = document.querySelector('.MainFlyout__level1 .MainFlyout__link--active')?.dataset?.level;;
  let level2Name;
  let level2Url;
  let requestLevel3Data;

  if(isEventTypeHoverIntent) {
    level2Name = event?.textContent;
    level2Url = event?.getAttribute('href');
  } else {
    level2Name = event?.target?.textContent;
    level2Url = event?.target?.getAttribute('href');
  }
  
  if (event.type !== 'click') {
    //handle highlighting selected link and stop touch handling
    if(isEventTypeHoverIntent) {
      headerMainFlyout.stopTouchHandling(event);
      headerMainFlyout.highlightLink('.MainFlyout__level2', event);
    } else {
      headerMainFlyout.stopTouchHandling(event);
      headerMainFlyout.highlightLink('.MainFlyout__level2', event?.target);
    }
    
    requestLevel3Data = headerData.getLevel3Data(level1Name, level2Name);

    requestLevel3Data.then(function _renderLevel3Data(level3Data) {
      const htmlContent = Mustache.render(headerMainFlyout.templates.desktopSection, {
        header: level2Name,
        links: level3Data,
        allLink: headerMainFlyout.clearUrl(level2Url),
        name: level2Name,
        direct: true
      });

      // Update the content
      utils.setInnerHtml('.MainFlyout__level3', htmlContent);

      // Open the menu
      headerMainFlyout.setMenuState('level3');
    });

    // If it failed - could be that the index doesn't exist, or that its got no results
    requestLevel3Data.catch(function _interactWithLevel2LinkFailure() {
      headerMainFlyout.setMenuState('level2');

      if ((event.type === 'touchend') && (level2Url !== '#')) {
        // log the event
        headerMainFlyout.logEventPath('header click', ['all departments', level1Name, level2Name]);

        // Go where we were going any way - have to do this since we prevented the default to wait for ajax
        window.location = level2Url;
      }
    });
    // if its click and the link is dead
  } else if (level2Url === '#') {
    event.preventDefault();
    event.stopPropagation();
  } else {
    headerMainFlyout.logEventPath('header click', ['all departments', level1Name, level2Name]);
  }
};

headerMainFlyout.notifyMenuState = function _notifyMenuState(state) {
  // Use a namespaced event, pass along the state
  $(document).trigger('menuState', [{
    isOpen: state,
    menu: 'main'
  }]);
};

headerMainFlyout.logMainMenuClick = function _logMainMenuClick(event) {
  // Find the closest anchor tag
  const level1Name = document.querySelector('.MainFlyout__level1 .MainFlyout__link--active')?.dataset?.level;
  const level2Name = document.querySelector('.MainFlyout__level2 .MainFlyout__link--active')?.textContent;
  let path = ['all departments', level1Name];
  const url = event?.target?.getAttribute('href');

  if (event && (event?.type === 'touchend')) {
    event.preventDefault();
  }

  if (level2Name) {
    path.push(level2Name);
  }

  path.push(event?.target?.textContent);

  headerMainFlyout.logEventPath('header click', path);

  if (event.type === 'touchend') {
    // because we prevented the touchend with preventDefault to stop click... it also stops the touchend.
    window.location = url;
  }
};

headerMainFlyout.renderL1Categories = function _renderL1Categories() {
  let requestLevel1Data = headerData.getLevel1Data();
  requestLevel1Data.then(function _renderLevel1Data(level1Data) {
    const htmlContent = Mustache.render(headerMainFlyout.templates.level1Flyout, { l1: level1Data });
    utils.emptyElement('.MainFlyout__level1Wrapper');
    utils.setInnerHtml('.MainFlyout__level1Wrapper', htmlContent);
    
    //registering event listeners for MainFlyout level1 after they are added
    headerMainFlyout.registerHoverIntent('.MainFlyout__level1 .MainFlyout__link', headerMainFlyout.interactWithLevel1Link);
  });
};

headerMainFlyout.registerHoverIntent = function _registerHoverIntent(selector, handler) {
  new SV.HoverIntent(document.querySelectorAll(selector), {
    onEnter: (targetItem) => {
      handler(targetItem);
    },
    onExit: () => { }
  })
};

// bind to all the necessary elements
headerMainFlyout.initialize = function initialize() {
  const events = ['click', 'touchend'];
  utils.addListenersToAll(['click', 'touchend', 'hoverintent'], '.MainFlyout__level1 .MainFlyout__link', headerMainFlyout.interactWithLevel1Link);
  utils.delegateListeners(events, '.MainFlyout__level2 .MainFlyout__link:not([data-type="direct"])', headerMainFlyout.interactWithLevel2Link);
  utils.delegateListeners(events, '.MainFlyout__level2 .MainFlyout__link[data-type="direct"]', headerMainFlyout.logLevel2Link);
  utils.delegateListeners(events, '.MainFlyout__level1Details a', headerMainFlyout.logMainMenuClick);
  utils.delegateListeners(events, '.MainFlyout__level3 .MainFlyout__link', headerMainFlyout.logMainMenuClick);
  utils.delegateListeners(events, '.MainFlyout__level2 .MainFlyout__header', headerMainFlyout.logLevel2Link);
  utils.delegateListeners(events, '.MainFlyout__level3 .MainFlyout__header', headerMainFlyout.logMainMenuClick);
};

headerMainFlyout.init = function init() {
  headerMainFlyout.initialize();

  // start loading the data now.
  headerData.init();

  // Render the L1 Categories
  if (hfConfig.flyoutVersion === '8') {
    headerMainFlyout.renderL1Categories();
  }

  return this;
};

headerMainFlyout.getPrivateMethods = () => headerMainFlyout;

export default headerMainFlyout;